import { AUTH_STORAGE_KEYS } from "@/shared/config/auth"
import type { UserRole } from "@/shared/lib/types"

/**
 * Роль текущего пользователя из сохранённой сессии. Страницы, перенесённые из
 * мини-аппа, спрашивают её перед тем, как показать админские действия.
 */
export const useSessionRole = () => {
	const userJson = sessionStorage.getItem(AUTH_STORAGE_KEYS.USER)
	if (!userJson) {
		return { role: "USER" as UserRole, isAdmin: false, isModerator: false }
	}

	try {
		const user = JSON.parse(userJson)
		const role = (user?.role ?? "USER") as UserRole
		return {
			role,
			isAdmin: role === "ADMIN",
			isModerator: role === "MODERATOR" || role === "ADMIN",
		}
	} catch {
		return { role: "USER" as UserRole, isAdmin: false, isModerator: false }
	}
}
